<template>
  <div class="page-title">
    <h3>{{ title }}</h3>
    <slot />
  </div>
</template>

<script>
export default {
  name: "BusinessStoreLocatorPageHeader",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  margin-top: $spacing;
  margin-bottom: $spacing * 3.5;

  h3 {
    @include font-size(22px);
  }
}
</style>
